import React from 'react';
import {observer} from 'mobx-react';
import {MatchEventsModuleEventImages} from "./match-events-module.event.images";
import {MatchEventsModuleEventContent} from "./match-events-module.event.content";
import {MatchEventsModuleEventIcon} from './match-events-module.event.icon';
import styles from "../../styles/match-event.module.scss";
import classNames from "classnames";
import {MATCH_EVENTS} from "../../match-events-widget.consts";
import {Link} from "../../../../../../core/components/link/link";
import {AthleteLinkModel} from "../../../../../../containers/athlete-container/models/athlete-link-model";
import {ACTION_TYPES} from "../../../../../../core/consts";
import {APP} from "../../../../../../core/app/consts";

export const MatchEventsModuleEventDetails = observer(({
                                                         event,
                                                         controller,
                                                         positionDown,
                                                         swapDirection,
                                                         isPenalties,
                                                       }) => {
  const {state, device} = controller;
  const {hasAnyPlayerStat, currentLinkModel, isWidget} = state;
  const {isRtl} = device;
  const isReverseAlignment: Boolean = (swapDirection && !isRtl) || (!swapDirection && isRtl);
  const playerLinkModel: AthleteLinkModel = (event.player.athleteId ? event.player.linkModel : null);

  const startImagesProps = {
    event,
    controller,
    swapDirection
  };

  const contentProps = {
    event,
    controller,
    swapDirection
  };

  const eventIconProps = {
    event,
    isPenalties,
    positionDown
  };

  const containerClassName: String = classNames(styles.event_details,
    {[styles.clickable_event_details]: event.player.athleteId},
    {[styles.event_details_reverse]: isReverseAlignment},
    {[styles.event_details_home_animations]: !swapDirection},
    {[styles.event_details_away_animations]: swapDirection});

  const onRowClick = (player) => {
    onEntityClick(player)
    controller.action(MATCH_EVENTS.ACTION_TYPES.onPlayerCardPopupClick, {
      isVisible: true,
      selectedAthleteId: player.athleteId
    });
  }

  const onEntityClick = (player) => controller.action(ACTION_TYPES.entityClick, {
    entityId: player?.athleteId || player.id,
    entityName: player.nameForURL,
    entityType: APP.ANALYTICS.USER_SELECTIONS.TYPES.AthleteViewModel,
    source: APP.ANALYTICS.SOURCES.match,
    sportTypeId: player.sport.id,
    currentLinkModel
  })

  const containerProps = {
    className: containerClassName,
    model: (event.isStaff || ((!hasAnyPlayerStat || isWidget) && event.player.athleteId)) ? playerLinkModel : null,
    onClick: () => event.player.athleteId ? (!event.isStaff && hasAnyPlayerStat && !isWidget ? onRowClick(event.player) : onEntityClick(event.player)) : null
  }

  return (
    <Link {...containerProps}>
      {
        !swapDirection ? <MatchEventsModuleEventImages {...startImagesProps} /> : null
      }
      {
        swapDirection ? <MatchEventsModuleEventIcon {...eventIconProps}/> : null
      }
      <MatchEventsModuleEventContent {...contentProps}/>
      {
        !swapDirection ? <MatchEventsModuleEventIcon {...eventIconProps}/> : null
      }
      {
        swapDirection ? <MatchEventsModuleEventImages {...startImagesProps} /> : null
      }
    </Link>
  )
});
